<template>
  <div class="device_wrap">
    <!-- <div class="choose-device">
      <div v-for="(item, index) in checkDevice" class="device" :key="index">
        <el-tag size="small" @close="handleCloseTag(item)" closable>{{ item.carNum }}</el-tag>
      </div>
    </div> -->
    <div style="display: flex;">
      <el-input v-model="carNum" placeholder="请输入车牌号" clearable></el-input>
      <el-button type="primary" @click="getDevice" style="margin-left: 10px;">查询</el-button>
      <el-button type="info" @click="resetQuery">重置</el-button>
    </div>
    <ioc-table ref="deviceMultipleTable" :data="tableData" :option="constData.deviceSelectTable" :page="constData.page"
      @selection-change="handleSelectionChange" @search-change="handleSearchChange" @search-reset="handleSearchReset"
      @size-change="handleSizeChange" @current-change="handleCurrentChange">
    </ioc-table>
  </div>
</template>

<script>
import utils from "@src/common/utils";
import { api } from "../api/index";
import { carSelect } from "../config/carSelect";
export default {
  name: 'carSelect',
  props: {
    updateCarsData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      constData: {
        deviceSelectTable: carSelect(true),
        page: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        searchForm: {},
      },
      tableData: [],
      checkDevice: [],
      subLoading: false,
      showDevicePanel: true,
      carNum: "",
    };
  },
  created() {
    this.resetQuery()
  },
  mounted() {
    if (this.updateCarsData.length > 0) {
      this.constData.deviceSelectTable.selection = false
    } else {
      this.constData.deviceSelectTable.selection = true
    }
  },
  methods: {
    resetQuery() {
      this.carNum = ""
      this.getDevice()
    },
    getDevice() {
      if (this.updateCarsData.length > 0) {
        this.tableData = this.updateCarsData;
        this.constData.page.total = 1;
        this.$nextTick(() => {
          this.$refs.deviceMultipleTable.$refs.multipleTable.toggleRowSelection(this.tableData[0], true);
        })
      } else {
        let params = {
          plateCode: this.carNum,
          auth: '0',
          pageNum: this.constData.page.pageNum,
          pageSize: this.constData.page.pageSize,
        };
        this.$fetch(api.queryVehicleAuthority, params).then((response) => {
          if (response.success) {
            this.tableData = response.returnObj.list;
            this.constData.page.total = response.returnObj ? response.returnObj.total : 0;
          } else {
            this.$message.error(response.msgContent);
          }
        });
      }
    },
    handleSearchChange(param) {
      this.constData.page.pageNum = 1;
      this.constData.searchForm = Object.assign({}, param);
      this.getDevice();
    },
    // 条件重置
    handleSearchReset() {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = 10;
      this.constData.searchForm = {};
      this.getDevice();
    },
    // 分页查询
    handleCurrentChange(val) {
      this.constData.page.pageNum = val;
      this.getDevice();
    },
    // 条数查询
    handleSizeChange(val) {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = val;
      this.getDevice();
    },
    // 多选
    handleSelectionChange(row) {
      this.checkDevice = [...row];
      this.$emit("carData", this.checkDevice)
    },
    handleCloseTag(item) {
      this.$refs.deviceMultipleTable.$refs.multipleTable.toggleRowSelection(item, false);
    },
    clearSelect() {
      if (this.checkDevice.length > 0) {
        this.$refs.deviceMultipleTable.$refs.multipleTable.clearSelection();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.device_wrap {
  width: 95%;
  height: 100%;
  display: flex;
  flex-direction: column;


  .choose-device {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 6px;

    .device {
      margin: 0px 5px 5px;
    }
  }
}
</style>
